import axios from "axios";
import { registerInterceptors } from "../interceptors/register";
import { Environment } from "../../shared/lib/environment";

const apiInstances = {
  gatewayApiInstance: axios.create({
    baseURL: import.meta.env.VITE_GATEWAY_API_URL,
  }),
  hitlApiInstance: axios.create(),
  posApiInstance: axios.create(),
  zoneApiInstance: axios.create(),
  streamsApiInstance: axios.create(),
};

export const { gatewayApiInstance, hitlApiInstance, zoneApiInstance, posApiInstance, streamsApiInstance } =
  apiInstances;

export const updateGlobalAPIBaseURLs = (environment: Environment) => {
  posApiInstance.defaults.baseURL = environment["rms-mapper"];
  zoneApiInstance.defaults.baseURL = environment["zone"];
  hitlApiInstance.defaults.baseURL = environment["sib"];
  streamsApiInstance.defaults.baseURL = environment["sdp"];
};

registerInterceptors(apiInstances);
